import React, { useId } from 'react';

import { BOLT_PATH, BOLT_VIEW_BOX, DISCHARGES, SPARK_PATH } from './priority-bolt.data';
import * as Styled from './priority-bolt.styles';

// A still bolt: at every discharge its glow flares and a couple of sparks fly off it
const PriorityBolt: React.FC = () => {
  // A gradient is found by its id in the whole document, so every bolt needs its own one
  const gradientId = useId();

  return (
    <Styled.Bolt aria-hidden="true">
      <Styled.Glow viewBox={BOLT_VIEW_BOX}>
        <path d={BOLT_PATH} />
      </Styled.Glow>
      <Styled.Layer viewBox={BOLT_VIEW_BOX}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor={Styled.BOLT_GRADIENT.top} />
            <stop offset="1" stopColor={Styled.BOLT_GRADIENT.bottom} />
          </linearGradient>
        </defs>
        <path d={BOLT_PATH} fill={`url(#${gradientId})`} />
      </Styled.Layer>
      <Styled.Layer viewBox={BOLT_VIEW_BOX}>
        {DISCHARGES.map((sparks, discharge) =>
          sparks.map(({ x, y, angle }, order) => (
            <g key={`${x} ${y}`} transform={`translate(${x} ${y}) rotate(${angle})`}>
              <Styled.Spark $discharge={discharge} $order={order}>
                <Styled.SparkHalo d={SPARK_PATH} />
                <Styled.SparkLine d={SPARK_PATH} />
              </Styled.Spark>
            </g>
          )),
        )}
      </Styled.Layer>
    </Styled.Bolt>
  );
};

export default React.memo(PriorityBolt);
